import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HomeIcon, MagnifyingGlassIcon, UserCircleIcon, ArrowLeftIcon, PhoneIcon, MapIcon } from "@heroicons/react/24/solid";
interface MobileBottomBarProps {
  variant?: "home" | "shop";
  onBack?: () => void;
  onCall?: () => void;
  onDirections?: () => void;
}

// Navigation items - Bookings and Messages are hidden for now (not deleted -
// see MessagesPage/BookingPage etc, which are untouched and still routable
// directly if needed while this is disabled).
const getNavItems = () => {
  return [
    {
      label: "Home",
      icon: <HomeIcon className="w-6 h-6" />,
      to: "/",
    },
    {
      label: "Search",
      icon: <MagnifyingGlassIcon className="w-6 h-6" />,
      to: "/search",
    },
    {
      label: "Profile",
      icon: <UserCircleIcon className="w-6 h-6" />,
      to: "/profile",
    },
  ];
};

const MobileBottomBar: React.FC<MobileBottomBarProps> = ({ variant = "home", onBack, onCall, onDirections }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = getNavItems();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg md:hidden font-sans">
      <div className="flex justify-around items-center h-16">
        {variant === "home" &&
          navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => navigate(item.to)}
              className={`flex flex-col items-center text-xs font-medium transition-colors relative ${
                location.pathname === item.to
                  ? "text-orange-600"
                  : "text-gray-500 hover:text-orange-500"
              }`}
              style={{ fontFamily: "Inter, ui-sans-serif, system-ui" }}
            >
              <div className="relative">
                {item.icon}
              </div>
              <span className="mt-1">{item.label}</span>
            </button>
          ))}
        {variant === "shop" && (
          <>
            <button
              onClick={onBack}
              className="flex flex-col items-center text-xs font-medium text-gray-500 hover:text-orange-500"
              style={{ fontFamily: "Inter, ui-sans-serif, system-ui" }}
            >
              <ArrowLeftIcon className="w-6 h-6" />
              <span className="mt-1">Back</span>
            </button>
            <button
              onClick={onCall}
              className="flex flex-col items-center text-xs font-medium text-gray-500 hover:text-orange-500"
              style={{ fontFamily: "Inter, ui-sans-serif, system-ui" }}
            >
              <PhoneIcon className="w-6 h-6" />
              <span className="mt-1">Call</span>
            </button>
            <button
              onClick={onDirections}
              className="flex flex-col items-center text-xs font-medium text-gray-500 hover:text-orange-500"
              style={{ fontFamily: "Inter, ui-sans-serif, system-ui" }}
            >
              <MapIcon className="w-6 h-6" />
              <span className="mt-1">Directions</span>
            </button>
          </>
        )}
      </div>
    </nav>
  );
};

export default MobileBottomBar;
